// The iOS / Android store badges for every download hand-off (Get the app, and the
// screen for patients who already have an account). An unset URL means the app is
// not in that store yet: render no link at all rather than a dead '#' (ClaimSuccess
// established this behaviour with its StoreBadge). Both URLs are build-time env,
// defaulted in deploy/deploy.sh.
import type { CSSProperties } from 'react';
import { card } from './ui';

const APP_STORE = import.meta.env.VITE_APP_STORE_URL || '';
const PLAY_STORE = import.meta.env.VITE_PLAY_STORE_URL || '';

const badge: CSSProperties = { ...card, padding: '12px 18px', fontWeight: 800, fontSize: 14 };

// `style` lets each screen set its own spacing and alignment around the row.
export function StoreBadges({ style }: { style?: CSSProperties }) {
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', ...style }}>
      {APP_STORE && (
        <a href={APP_STORE} target="_blank" rel="noreferrer" style={badge}>
          Download on iOS
        </a>
      )}
      {PLAY_STORE ? (
        <a href={PLAY_STORE} target="_blank" rel="noreferrer" style={badge}>
          Get it on Android
        </a>
      ) : (
        <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--slate)' }}>Android coming soon</span>
      )}
    </div>
  );
}
